import {useQuery} from 'react-query';
import {useSetRecoilState} from 'recoil';
import actions from '../../api/news/news';
import {singleNews} from '../../state/news/singleNews';

const useFetchSingleNews = (slug: string) => {
  const setNews = useSetRecoilState(singleNews);

  return useQuery(['useFetchSingleNews', slug], async () => {
    const newsItem = await actions.fetchSingleNews(slug);
    setNews(newsItem);
    return newsItem;
  }, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};

export default useFetchSingleNews;
